export default "__VITE_ASSET__CbRKuTYp__"